import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useHttp } from "../../hooks/use-http";
import { EventItemDetail } from "../../components/Events/EventItemDetail";
import { EventItemSideBar } from "../../components/Sidebar/Events/EventItemSideBar";
import { ReportIssue } from "../../components/Sidebar/General/ReportIssue";
import { StyledSectionHeaderComponent, StyledListSection, StyledListContainer, StyledListSideBarColumn } from "../../utils/common-styles";
import { LoadingEventItemDetail } from "../../components/Extra/Loading/LoadingEventItemDetail";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../../utils/utils";

export const EventDetailPage = (props) => {
  const { id, slug } = useParams();

  const [eventItem, setEventItem] = useState({});
  const [otherEvents, setOtherEvents] = useState([]);

  const { isLoading, error, sendRequest: getContent } = useHttp();

  useEffect(() => {
    const parseContent = (data) => {
      let eventItem = data?.payload?.item;
      let otherEvents = data?.payload?.other;
      setEventItem((prevState) => {
        return { ...prevState, ...eventItem };
      });

      setOtherEvents((prevState) => {
        return otherEvents;
      });
    };

    let url = `/events/item/${id}/detail`;
    getContent({ url }, parseContent);
  }, [id, slug, getContent]);

  return (
    <>
      <Helmet>
        <title>{eventItem?.title ? `${eventItem.title} - Friends of Queen's Wood` : 'Friends of Queen\'s Wood'}</title>
        <meta name="description" content={eventItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={eventItem?.title || 'Friends of Queen\'s Wood'} />
        <meta property="og:description" content={eventItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
        <meta property="og:url" content={`${window.location.origin}/events/${id}/${slug}`} />
        <meta property="og:image" content={eventItem?.image_details?.variations?.detail_hero || UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content={eventItem?.title || 'Friends of Queen\'s Wood'} />
        <meta name="twitter:description" content={eventItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
        <meta name="twitter:image" content={eventItem?.image_details?.variations?.detail_hero || UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="Upcoming event" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              {isLoading && <LoadingEventItemDetail />}
              {!isLoading && <EventItemDetail post={eventItem} />}
              {error && <p style={{ color: "red" }}>{error}</p>}
            </Col>
            <StyledListSideBarColumn xs={12} md={3}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              {!isLoading && (
                <EventItemSideBar post={eventItem} other={otherEvents} />
              )}
              <ReportIssue />
            </StyledListSideBarColumn>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
